var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"mb-2"},[_vm._v("Creative Dimensions")]),_c('v-combobox',{attrs:{"items":_vm.available_dimensions,"label":"Dimensions","outlined":"","dense":"","multiple":"","chips":"","small-chips":"","deletable-chips":""},model:{value:(_vm.dimension),callback:function ($$v) {_vm.dimension=$$v},expression:"dimension"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }